// TelcoTrack — required polygon fields before Project Drive folder bootstrap.

import {
  projectDriveBranchFolder,
  projectDriveRealizationYear,
} from '../constants/project-drive-folder.constants';
import { readPolygonInvestorFromMetadata } from './polygon-investor.util';

export type ProjectDriveBootstrapIdentity = {
  name?: string | null;
  realizationYear?: string | null;
  responsibleBranch?: string | null;
  companyId?: string | null;
  /** Explicit investor; otherwise read from `metadata`. */
  investor?: string | null;
  metadata?: unknown;
};

export function resolvePolygonDriveInvestor(identity: ProjectDriveBootstrapIdentity): string | null {
  const direct = asNonEmptyString(identity.investor);
  if (direct) return direct;
  return readPolygonInvestorFromMetadata(identity.metadata);
}

export function projectDriveMissingIdentityFields(identity: ProjectDriveBootstrapIdentity): string[] {
  const missing: string[] = [];
  if (!asNonEmptyString(identity.name)) missing.push('název');
  if (!resolvePolygonDriveInvestor(identity)) missing.push('investora');
  if (!projectDriveRealizationYear(identity.realizationYear)) missing.push('rok');
  if (!projectDriveBranchFolder(identity.responsibleBranch)) missing.push('pobočku');
  if (!asNonEmptyString(identity.companyId)) missing.push('firmu');
  return missing;
}

export function projectDriveHasIdentity(identity: ProjectDriveBootstrapIdentity): boolean {
  return projectDriveMissingIdentityFields(identity).length === 0;
}

function asNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
